import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "table table-sm" }
const _hoisted_2 = {
  key: 0,
  style: {"width":"30%"}
}
const _hoisted_3 = {
  key: 1,
  style: {"width":"40%"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("col", { style: {"width":"10%"} }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("col", { style: {"width":"10%"} }, null, -1)
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "bg-light" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "text-end"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "fw-bold" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "small text-muted" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 2,
  class: "text-end"
}
const _hoisted_17 = {
  type: "button",
  class: "btn btn-link text-dark"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["colspan"]
const _hoisted_20 = { class: "pt-2 px-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_CatalogProductsTableActions = _resolveComponent("CatalogProductsTableActions")!
  const _component_DropdownPopper = _resolveComponent("DropdownPopper")!
  const _component_ItemConfiguredOptions = _resolveComponent("ItemConfiguredOptions")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("colgroup", null, [
      (_ctx.allCatalogs)
        ? (_openBlock(), _createElementBlock("col", _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.allCatalogs)
        ? (_openBlock(), _createElementBlock("col", _hoisted_3))
        : _createCommentVNode("", true),
      _hoisted_4,
      _hoisted_5,
      (_ctx.actionsEnabled)
        ? (_openBlock(), _createElementBlock("col", _hoisted_6))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("thead", null, [
      _createElementVNode("tr", _hoisted_7, [
        (_ctx.allCatalogs)
          ? (_openBlock(), _createElementBlock("th", _hoisted_8, [
              _createElementVNode("small", null, _toDisplayString(_ctx.t('CatalogCode')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.allCatalogs)
          ? (_openBlock(), _createElementBlock("th", _hoisted_9, [
              _createElementVNode("small", null, _toDisplayString(_ctx.t('Description')), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("th", null, [
          _createElementVNode("small", null, _toDisplayString(_ctx.t('Quantity')), 1)
        ]),
        _createElementVNode("th", null, [
          _createElementVNode("small", null, _toDisplayString(_ctx.t('UnitOfMeasure')), 1)
        ]),
        (_ctx.actionsEnabled)
          ? (_openBlock(), _createElementBlock("th", _hoisted_10, [
              _createElementVNode("small", null, _toDisplayString(_ctx.t('Actions')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.catalogs, (cat) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: cat.catalogId!.code + cat.catalogId!.owner
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cat.quantities, (qty) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: qty.quantityId
            }, [
              _createElementVNode("tr", {
                class: _normalizeClass({
              'no-border-bottom': qty.configuredProductIds && qty.configuredProductIds.length,
            })
              }, [
                (_ctx.allCatalogs)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("a", {
                          href: "",
                          onClick: _withModifiers(($event: any) => (_ctx.details(cat.catalogId!)), ["prevent"])
                        }, _toDisplayString(cat.catalogId?.code), 9, _hoisted_13)
                      ]),
                      _createElementVNode("div", _hoisted_14, _toDisplayString(cat.catalogId?.owner), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.allCatalogs)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                      _createElementVNode("div", null, _toDisplayString(cat.description), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, _toDisplayString(qty.value), 1),
                _createElementVNode("td", null, _toDisplayString(qty.unitOfMeasure), 1),
                (_ctx.actionsEnabled)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                      (cat.editable)
                        ? (_openBlock(), _createBlock(_component_DropdownPopper, {
                            key: 0,
                            placement: "bottom-start",
                            interactive: true,
                            class: "d-inline-block"
                          }, {
                            trigger: _withCtx(() => [
                              _createElementVNode("button", _hoisted_17, [
                                _createVNode(_component_Icon, { glyph: "menu" })
                              ])
                            ]),
                            dropdown: _withCtx(({ close }) => [
                              _createVNode(_component_CatalogProductsTableActions, {
                                t: _ctx.t,
                                close: close,
                                "instance-id": _ctx.instanceId,
                                product: _ctx.item,
                                catalog: cat,
                                quantity: qty,
                                editable: cat.editable
                              }, null, 8, ["t", "close", "instance-id", "product", "catalog", "quantity", "editable"])
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              (qty.configuredProductIds && qty.configuredProductIds.length)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                    _createElementVNode("td", {
                      colspan: _ctx.allCatalogs ? 5 : 3
                    }, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_ItemConfiguredOptions, {
                          "instance-id": _ctx.instanceId,
                          qty: qty,
                          item: _ctx.item,
                          catalog: cat,
                          t: _ctx.t
                        }, null, 8, ["instance-id", "qty", "item", "catalog", "t"])
                      ])
                    ], 8, _hoisted_19)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ], 64))
      }), 128))
    ])
  ]))
}